import extensions from './extensions';
import preferences from './preferences';
import servers from './servers';
import studies from './studies';
import timepointManager from './timepointManager';
import viewingUserManager from './viewingUserManager';
import viewports from './viewports';
import storageManager from './storageManager';
// notificationは2022/11/8時点では不使用
import notificationsManeger from './notification';

const reducers = {
  extensions,
  preferences,
  servers,
  studies,
  timepointManager,
  viewingUserManager,
  viewports,
  storageManager,
  notificationsManeger,
};

export default reducers;
